import { appRoutes } from '@/apps/registry';

const project = process.env.VUE_APP_PROJECT;

const routes = [
    // ── Mobile App-Plattform ─────────────────────────────────
    {
        path: '/app',
        component: () => import('@/layouts/ScanLayout.vue'),
        meta: { scan: true, context: 'scan', title: 'CityOffer App' },
        children: [
            {
                path: '',
                redirect: { name: 'app-home' },
            },
            {
                path: 'home',
                name: 'app-home',
                component: () => import('@/views/scan/Home.vue'),
                meta: { scan: true, context: 'scan', title: 'CityOffer App' },
            },
            {
                path: 'events',
                name: 'scan-events',
                component: () => import('@/views/scan/Events.vue'),
                meta: { scan: true, context: 'scan', title: 'CityOffer App', backTo: 'app-home' },
            },
            {
                path: 'event/:id',
                name: 'scan-scanner',
                component: () => import('@/views/scan/Scanner.vue'),
                meta: { scan: true, context: 'scan', title: 'CityOffer App', backTo: 'scan-events' },
            },
            {
                path: 'products',
                name: 'scan-products',
                component: () => import('@/views/scan/products/List.vue'),
                meta: { scan: true, context: 'scan', title: 'CityOffer App', backTo: 'app-home' },
            },
            {
                path: 'product/:id',
                name: 'scan-product',
                component: () => import('@/views/scan/products/Detail.vue'),
                meta: { scan: true, context: 'scan', title: 'CityOffer App', backTo: 'scan-products' },
            },
            {
                path: 'article/:id',
                name: 'scan-article',
                component: () => import('@/views/scan/products/Detail.vue'),
                meta: { scan: true, context: 'scan', title: 'CityOffer App', backTo: 'scan-products' },
            },
        ],
    },
    {
        path: '/',
        name: 'dashboard',
        component: () => import('@/views/cms/Dashboard/index.vue'),
        meta: {
            title: project + ' Dashboard',
            context: 'main',
        },
    },
    // Category Posts
    {
        path: '/posts/:key?',
        name: 'posts',
        component: () => import('@/views/cms/CategoryPage/List.vue'),
        meta: {
            title: project + ' Posts',
            restrictions: {
                extensions: [],
                permissions: ['cp:posts'],
            },
            context: 'cms',
        },
    },
    {
        path: '/post/:key?/:id?',
        name: 'post-form',
        component: () => import('@/views/cms/CategoryPage/Form.vue'),
        meta: {
            title: project + ' Post',
            parent: 'posts',
            restrictions: {
                extensions: [],
                permissions: ['cp:posts'],
            },
            context: 'cms',
        },
        children: [
            {
                path: '/post/:key/:id/main',
                name: 'post-main',
                component: () => import('@/views/cms/CategoryPage/Form/Main.vue'),
                meta: {
                    title: project + ' Content',
                    restrictions: {
                        extensions: [],
                        permissions: ['cp:posts'],
                    },
                    context: 'cms',
                },
            },
            {
                path: '/post/:key/:id/meta',
                name: 'post-meta',
                component: () => import('@/views/cms/CategoryPage/Form/Meta.vue'),
                meta: {
                    title: project + ' Meta',
                    restrictions: {
                        extensions: [],
                        permissions: ['cp:posts'],
                    },
                    context: 'cms',
                },
            },
            {
                path: '/post/:key/:id/settings',
                name: 'post-settings',
                component: () => import('@/views/cms/CategoryPage/Form/Settings.vue'),
                meta: {
                    title: project + ' Settings',
                    restrictions: {
                        extensions: [],
                        permissions: ['cp:posts'],
                    },
                    context: 'cms',
                },
            },
            {
                path: '/post/:key/:id/filters',
                name: 'post-filters',
                component: () => import('@/views/cms/CategoryPage/Form/Filters.vue'),
                meta: {
                    title: project + ' Filters',
                    restrictions: {
                        extensions: [],
                        permissions: ['cp:posts'],
                    },
                    context: 'cms',
                },
            },
        ],
    },
    // Menus
    {
        path: '/menu/:key?',
        name: 'menu-form',
        component: () => import('@/views/cms/Menu/Form.vue'),
        meta: {
            title: project + ' Menu',
            restrictions: {
                extensions: [],
                permissions: ['cp:menus'],
            },
            context: 'cms',
        },
        children: [
            {
                path: '/menu/:key?/:id?',
                name: 'menu-item',
                component: () => import('@/views/cms/Menu/Form/Item.vue'),
                meta: {
                    title: project + ' Menu Item',
                    restrictions: {
                        extensions: [],
                        permissions: ['cp:menus'],
                    },
                    context: 'cms',
                },
            },
        ],
    },
    // Events
    {
        path: '/event-manager',
        name: 'event-manager',
        redirect: '/event-manager/events',
        meta: {
            restrictions: {
                extensions: ['event-manager'],
                permissions: ['ex:evnt'],
            },
        },
    },
    {
        path: '/event-manager/events',
        name: 'events',
        component: () => import('@/extensions/eventManager/views/Event/List.vue'),
        meta: {
            title: project + ' Events',
            parent: 'event-manager',
            restrictions: {
                extensions: ['event-manager'],
                permissions: ['ex:evnt', 'ex:evnt:events'],
            },
            context: 'event-manager',
        },
    },
    {
        path: '/event-manager/event/:id?',
        name: 'event-form',
        component: () => import('@/extensions/eventManager/views/Event/Form.vue'),
        meta: {
            title: project + ' Event',
            parent: 'event-manager',
            restrictions: {
                extensions: ['event-manager'],
                permissions: ['ex:evnt', 'ex:evnt:events'],
            },
            context: 'event-manager',
        },
        children: [
            {
                path: '/event-manager/event/:id/main',
                name: 'event-main',
                component: () => import('@/extensions/eventManager/views/Event/Form/Main.vue'),
                meta: {
                    title: project + ' Event',
                    restrictions: {
                        extensions: ['event-manager'],
                        permissions: ['ex:evnt', 'ex:evnt:events'],
                    },
                    context: 'event-manager',
                },
            },
            {
                path: '/event-manager/event/:id/slots',
                name: 'event-slots',
                component: () => import('@/extensions/eventManager/views/Event/Form/Slots.vue'),
                meta: {
                    title: project + ' Slots',
                    restrictions: {
                        extensions: ['event-manager'],
                        permissions: ['ex:evnt', 'ex:evnt:events'],
                    },
                    context: 'event-manager',
                },
            },
            {
                path: '/event-manager/event/:id/bookings',
                name: 'event-bookings',
                component: () => import('@/extensions/eventManager/views/Event/Form/Bookings.vue'),
                meta: {
                    title: project + ' Bookings',
                    restrictions: {
                        extensions: ['event-manager'],
                        permissions: ['ex:evnt', 'ex:evnt:events', 'ex:evnt:bookings'],
                    },
                    context: 'event-manager',
                },
            },
            {
                path: '/event-manager/event/:id/scan',
                name: 'event-scan',
                component: () => import('@/extensions/eventManager/views/Event/Form/Scan.vue'),
                meta: {
                    title: project + ' Scan',
                    restrictions: {
                        extensions: ['event-manager'],
                        permissions: ['ex:evnt', 'ex:evnt:events', 'ex:evnt:bookings'],
                    },
                    context: 'event-manager',
                },
            },
        ],
    },
    {
        path: '/event-manager/categories',
        name: 'event-category-list',
        component: () => import('@/extensions/eventManager/views/Category/List.vue'),
        meta: {
            title: project + ' Categories',
            parent: 'event-manager',
            restrictions: {
                extensions: ['event-manager'],
                permissions: ['ex:evnt', 'ex:evnt:categories'],
            },
            context: 'event-manager',
        },
    },
    {
        path: '/event-manager/category/:id?',
        name: 'event-category-form',
        component: () => import('@/extensions/eventManager/views/Category/Form.vue'),
        meta: {
            title: project + ' Category',
            parent: 'event-manager',
            restrictions: {
                extensions: ['event-manager'],
                permissions: ['ex:evnt', 'ex:evnt:categories'],
            },
            context: 'event-manager',
        },
        children: [
            {
                path: '/event-manager/category/:id/main',
                name: 'event-category-main',
                component: () => import('@/extensions/eventManager/views/Category/Form/Main.vue'),
                meta: {
                    title: project + ' Category',
                    restrictions: {
                        extensions: ['event-manager'],
                        permissions: ['ex:evnt', 'ex:evnt:categories'],
                    },
                    context: 'event-manager',
                },
            },
        ],
    },
    {
        path: '/event-manager/registration-templates',
        name: 'event-registration-template-list',
        component: () => import('@/extensions/eventManager/views/RegistrationTemplate/List.vue'),
        meta: {
            title: project + ' Registration Forms',
            parent: 'event-manager',
            restrictions: {
                extensions: ['event-manager'],
                permissions: ['ex:evnt', 'ex:evnt:events'],
            },
            context: 'event-manager',
        },
    },
    {
        path: '/event-manager/registration-template/:id?',
        name: 'event-registration-template-form',
        component: () => import('@/extensions/eventManager/views/RegistrationTemplate/Form.vue'),
        meta: {
            title: project + ' Registration Form',
            parent: 'event-manager',
            restrictions: {
                extensions: ['event-manager'],
                permissions: ['ex:evnt', 'ex:evnt:events'],
            },
            context: 'event-manager',
        },
        children: [
            {
                path: '/event-manager/registration-template/:id/main',
                name: 'event-registration-template-main',
                component: () => import('@/extensions/eventManager/views/RegistrationTemplate/Form/Main.vue'),
                meta: {
                    title: project + ' Registration Form',
                    restrictions: {
                        extensions: ['event-manager'],
                        permissions: ['ex:evnt', 'ex:evnt:events'],
                    },
                    context: 'event-manager',
                },
            },
        ],
    },
    {
        path: '/event-manager/bookings',
        name: 'event-booking-list',
        component: () => import('@/extensions/eventManager/views/Booking/List.vue'),
        meta: {
            title: project + ' Booking',
            parent: 'event-manager',
            restrictions: {
                extensions: ['event-manager'],
                permissions: ['ex:evnt', 'ex:evnt:bookings'],
            },
            context: 'event-manager',
        },
    },
    {
        path: '/event-manager/booking/:id?',
        name: 'event-booking-form',
        component: () => import('@/extensions/eventManager/views/Booking/Form.vue'),
        meta: {
            title: project + ' Booking',
            parent: 'event-manager',
            restrictions: {
                extensions: ['event-manager'],
                permissions: ['ex:evnt', 'ex:evnt:bookings'],
            },
            context: 'event-manager',
        },
        children: [
            {
                path: '/event-manager/booking/:id/main',
                name: 'event-booking-main',
                component: () => import('@/extensions/eventManager/views/Booking/Form/Main.vue'),
                meta: {
                    title: project + ' Booking',
                    restrictions: {
                        extensions: ['event-manager'],
                        permissions: ['ex:evnt', 'ex:evnt:bookings'],
                    },
                    context: 'event-manager',
                },
            },
        ],
    },
    // Catalog
    {
        path: '/catalog',
        name: 'catalog',
        redirect: '/catalog/products',
        meta: {
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop'],
            },
        },
    },
    {
        path: '/catalog/products',
        name: 'product-list',
        component: () => import('@/extensions/shop/views/Product/List.vue'),
        meta: {
            title: project + ' Products',
            parent: 'catalog',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:products'],
            },
            context: 'shop',
            // Multistore: this data lives on the shop and is shared with every
            // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
            sharedWithShop: true,
        },
    },
    {
        path: '/catalog/articles',
        name: 'article-list',
        component: () => import('@/extensions/shop/views/Article/List.vue'),
        meta: {
            title: project + ' Articles',
            parent: 'catalog',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:products'],
            },
            context: 'shop',
            // Multistore: this data lives on the shop and is shared with every
            // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
            sharedWithShop: true,
        },
    },
    {
        path: '/catalog/product/:id?',
        name: 'product-form',
        component: () => import('@/extensions/shop/views/Product/Form.vue'),
        meta: {
            title: project + ' Product',
            parent: 'catalog',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:products'],
            },
            context: 'shop',
            // Multistore: this data lives on the shop and is shared with every
            // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
            sharedWithShop: true,
        },
        children: [
            {
                path: '/catalog/product/:id/main',
                name: 'product-main',
                component: () => import('@/extensions/shop/views/Product/Form/Main.vue'),
                meta: {
                    title: project + ' Product',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:products'],
                    },
                    context: 'shop',
                    // Multistore: this data lives on the shop and is shared with every
                    // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
                    sharedWithShop: true,
                },
            },
            {
                path: '/catalog/product/:id/prices',
                name: 'product-prices',
                component: () => import('@/extensions/shop/views/Product/Form/Prices.vue'),
                meta: {
                    title: project + ' Product',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:products'],
                    },
                    context: 'shop',
                    // Multistore: this data lives on the shop and is shared with every
                    // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
                    sharedWithShop: true,
                },
            },
            {
                path: '/catalog/product/:id/articles',
                name: 'product-articles',
                component: () => import('@/extensions/shop/views/Product/Form/Articles.vue'),
                meta: {
                    title: project + ' Product',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:products'],
                    },
                    context: 'shop',
                    // Multistore: this data lives on the shop and is shared with every
                    // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
                    sharedWithShop: true,
                },
            },
            {
                path: '/catalog/product/:id/coupons',
                name: 'product-coupons',
                component: () => import('@/extensions/shop/views/Product/Form/Coupons.vue'),
                meta: {
                    title: project + ' Product',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:products'],
                    },
                    context: 'shop',
                    // Multistore: this data lives on the shop and is shared with every
                    // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
                    sharedWithShop: true,
                },
            },
        ],
    },
    {
        path: '/catalog/category',
        name: 'category-form',
        component: () => import('@/extensions/shop/views/Category/Form.vue'),
        meta: {
            title: project + ' Categories',
            parent: 'catalog',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:categories'],
            },
            context: 'shop',
            // Multistore: this data lives on the shop and is shared with every
            // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
            sharedWithShop: true,
        },
        children: [
            {
                path: '/catalog/category/:id?',
                name: 'category-form-item',
                component: () => import('@/extensions/shop/views/Category/Item.vue'),
                meta: {
                    title: project + ' Category',
                    parent: 'catalog',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:categories'],
                    },
                    context: 'shop',
                    // Multistore: this data lives on the shop and is shared with every
                    // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
                    sharedWithShop: true,
                },
            },
        ],
    },
    {
        path: '/catalog/property-sets',
        name: 'prop-set-list',
        component: () => import('@/extensions/shop/views/PropSet/List.vue'),
        meta: {
            title: project + ' Property Sets',
            parent: 'catalog',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:prop-sets'],
            },
            context: 'shop',
            // Multistore: this data lives on the shop and is shared with every
            // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
            sharedWithShop: true,
        },
    },
    {
        path: '/catalog/property-set/:id?',
        name: 'prop-set-form',
        component: () => import('@/extensions/shop/views/PropSet/Form.vue'),
        meta: {
            title: project + ' Order',
            parent: 'catalog',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:prop-sets'],
            },
            context: 'shop',
            // Multistore: this data lives on the shop and is shared with every
            // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
            sharedWithShop: true,
        },
        children: [
            {
                path: '/catalog/property-set/:id/main',
                name: 'prop-set-main',
                component: () => import('@/extensions/shop/views/PropSet/Form/Main.vue'),
                meta: {
                    title: project + ' Order',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:prop-sets'],
                    },
                    context: 'shop',
                    // Multistore: this data lives on the shop and is shared with every
                    // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
                    sharedWithShop: true,
                },
            },
        ],
    },
    {
        path: '/catalog/properties',
        name: 'property-list',
        component: () => import('@/extensions/shop/views/Property/List.vue'),
        meta: {
            title: project + ' Properties',
            parent: 'catalog',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:properties'],
            },
            context: 'shop',
            // Multistore: this data lives on the shop and is shared with every
            // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
            sharedWithShop: true,
        },
    },
    {
        path: '/catalog/property/:id?',
        name: 'property-form',
        component: () => import('@/extensions/shop/views/Property/Form.vue'),
        meta: {
            title: project + ' Order',
            parent: 'catalog',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:properties'],
            },
            context: 'shop',
            // Multistore: this data lives on the shop and is shared with every
            // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
            sharedWithShop: true,
        },
        children: [
            {
                path: '/catalog/property/:id/main',
                name: 'property-main',
                component: () => import('@/extensions/shop/views/Property/Form/Main.vue'),
                meta: {
                    title: project + ' Order',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:properties'],
                    },
                    context: 'shop',
                    // Multistore: this data lives on the shop and is shared with every
                    // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
                    sharedWithShop: true,
                },
            },
        ],
    },
    // Sales
    {
        path: '/sales',
        name: 'sales',
        redirect: '/sales/orders',
        meta: {
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop'],
            },
        },
    },
    {
        path: '/sales/orders',
        name: 'purchases', // "order / orders" is for seller buying stuff / refilling stock
        component: () => import('@/extensions/shop/views/Purchase/List.vue'),
        meta: {
            title: project + ' Orders',
            parent: 'sales',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:purchases'],
            },
            context: 'shop',
        },
    },
    {
        path: '/sales/order/:id?',
        name: 'purchase-form',
        component: () => import('@/extensions/shop/views/Purchase/Form.vue'),
        meta: {
            title: project + ' Order',
            parent: 'sales',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:purchases'],
            },
            context: 'shop',
        },
        children: [
            {
                path: '/sales/order/:id/main',
                name: 'purchase-main',
                component: () => import('@/extensions/shop/views/Purchase/Form/Main.vue'),
                meta: {
                    title: project + ' Order',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:purchases'],
                    },
                    context: 'shop',
                },
            },
            {
                path: '/sales/order/:id/customer',
                name: 'purchase-customer',
                component: () => import('@/extensions/shop/views/Purchase/Form/Customer.vue'),
                meta: {
                    title: project + ' Customer',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:purchases'],
                    },
                    context: 'shop',
                },
            },
            {
                path: '/sales/order/:id/articles',
                name: 'purchase-articles',
                component: () => import('@/extensions/shop/views/Purchase/Form/Articles.vue'),
                meta: {
                    title: project + ' Articles',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:purchases'],
                    },
                    context: 'shop',
                },
            },
            {
                path: '/sales/order/:id/messages/:conversationId?',
                name: 'purchase-messages',
                component: () => import('@/extensions/communication/views/Purchase/Messages.vue'),
                meta: {
                    title: project + ' Messages',
                    restrictions: {
                        extensions: ['shop', 'communication'],
                        permissions: ['ex:shop', 'ex:shop:purchases', 'ex:comm', 'ex:comm:messages'],
                    },
                    context: 'shop',
                },
            },
        ],
    },
    {
        path: '/sales/carts',
        name: 'cart-list',
        component: () => import('@/extensions/shop/views/Cart/List.vue'),
        meta: {
            title: project + ' Shopping Carts',
            parent: 'sales',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:shopping-carts'],
            },
            context: 'shop',
        },
    },
    {
        path: '/sales/cart/:id?',
        name: 'cart-form',
        component: () => import('@/extensions/shop/views/Cart/Form.vue'),
        meta: {
            title: project + ' Shopping Cart',
            parent: 'sales',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:shopping-carts'],
            },
            context: 'shop',
        },
        children: [
            {
                path: '/sales/cart/:id/main',
                name: 'cart-main',
                component: () => import('@/extensions/shop/views/Cart/Form/Main.vue'),
                meta: {
                    title: project + ' Shopping Cart',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:shopping-carts'],
                    },
                    context: 'shop',
                },
            },
            {
                path: '/sales/cart/:id/articles',
                name: 'cart-articles',
                component: () => import('@/extensions/shop/views/Cart/Form/Articles.vue'),
                meta: {
                    title: project + ' Shopping Cart Articles',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:shopping-carts'],
                    },
                    context: 'shop',
                },
            },
        ],
    },
    {
        path: '/sales/wish-lists',
        name: 'wish-list-list',
        component: () => import('@/extensions/shop/views/WishList/List.vue'),
        meta: {
            title: project + ' Wish Lists',
            parent: 'sales',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:wish-lists'],
            },
            context: 'shop',
        },
    },
    {
        path: '/sales/wish-list/:id?',
        name: 'wish-list-form',
        component: () => import('@/extensions/shop/views/WishList/Form.vue'),
        meta: {
            title: project + ' Wish List',
            parent: 'sales',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:wish-lists'],
            },
            context: 'shop',
        },
        children: [
            {
                path: '/sales/wish-list/:id/main',
                name: 'wish-list-main',
                component: () => import('@/extensions/shop/views/WishList/Form/Main.vue'),
                meta: {
                    title: project + ' Wish List',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:wish-lists'],
                    },
                    context: 'shop',
                },
            },
            {
                path: '/sales/wish-list/:id/articles',
                name: 'wish-list-articles',
                component: () => import('@/extensions/shop/views/WishList/Form/Articles.vue'),
                meta: {
                    title: project + ' Wish List Articles',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:shop:wish-lists'],
                    },
                    context: 'shop',
                },
            },
        ],
    },
    {
        path: '/sales/items',
        name: 'purchased-items',
        component: () => import('@/extensions/shop/views/PurchasedItem/List.vue'),
        meta: {
            title: project + ' Ordered Items',
            parent: 'sales',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:purchases'],
            },
            context: 'shop',
        },
    },
    {
        path: '/sales/cash-flow-logs',
        name: 'cash-flow-logs',
        component: () => import('@/extensions/shop/views/CashFlowLog/List.vue'),
        meta: {
            title: project + ' Cash Movements',
            parent: 'sales',
            restrictions: {
                extensions: ['shop', 'shop:point-of-sale'],
                permissions: ['ex:pos', 'ex:pos:points-of-sale'],
            },
            context: 'shop',
        },
    },
    //Reserve for sale menu
    {
        path: '/sales/reserve',
        name: 'sales-reserve',
        component: () => import('@/extensions/shop/views/Reserve/List.vue'),
        meta: {
            title: project + ' Point Of Sale',
            parent: 'sales',
            restrictions: {
                extensions: ['shop', 'shop:point-of-sale'],
                permissions: ['ex:pos', 'ex:pos:points-of-sale'],
            },
            context: 'shop',
        },
    },
    //Shipping for sale menu
    {
        path: '/sales/shipping',
        name: 'sales-shipping',
        component: () => import('@/extensions/shop/views/Shipping/List.vue'),
        meta: {
            title: project + ' Point Of Sale',
            parent: 'sales',
            restrictions: {
                extensions: ['shop', 'shop:point-of-sale'],
                permissions: ['ex:pos', 'ex:pos:points-of-sale'],
            },
            context: 'shop',
        },
    },
    // Point Of Sale
    {
        path: '/point-of-sale',
        name: 'point-of-sale',
        component: () => import('@/extensions/shop/pointOfSale/views/PointOfSale.vue'),
        meta: {
            title: project + ' Point Of Sale',
            restrictions: {
                extensions: ['shop', 'shop:point-of-sale'],
                permissions: ['ex:pos', 'ex:pos:points-of-sale'],
            },
            context: 'shop point-of-sale',
        },
        children: [
            {
                path: '/point-of-sale/put-aside',
                name: 'point-of-sale:put-aside',
                component: () => import('@/extensions/shop/pointOfSale/views/PutAside.vue'),
                meta: {
                    title: project + ' Point Of Sale',
                    restrictions: {
                        extensions: ['shop', 'shop:point-of-sale'],
                        permissions: ['ex:pos', 'ex:pos:points-of-sale'],
                    },
                    context: 'shop point-of-sale',
                },
            },
            {
                path: '/point-of-sale/reserve',
                props: { context: 'POS' },
                name: 'point-of-sale:reserve',
                component: () => import('@/extensions/shop/pointOfSale/views/Reserve.vue'),
                meta: {
                    title: project + ' Point Of Sale',
                    restrictions: {
                        extensions: ['shop', 'shop:point-of-sale'],
                        permissions: ['ex:pos', 'ex:pos:points-of-sale'],
                    },
                    context: 'shop point-of-sale',
                },
            },
            // {
            //     path: '/point-of-sale/stock',
            //     name: 'point-of-sale:stock',
            //     component: () => import('@/extensions/shop/pointOfSale/views/Stock.vue'),
            //     meta: {
            //         title: project + ' Point Of Sale',
            //         restrictions: {
            //             extensions: ['shop', 'shop:point-of-sale'],
            //             permissions: ['ex:pos', 'ex:pos:points-of-sale'],
            //         },
            //         context: 'shop point-of-sale'
            //     }
            // },
            {
                path: '/point-of-sale/shipping',
                props: { context: 'POS' },
                name: 'point-of-sale:shipping',
                component: () => import('@/extensions/shop/pointOfSale/views/Shipping.vue'),
                meta: {
                    title: project + ' Point Of Sale',
                    restrictions: {
                        extensions: ['shop', 'shop:point-of-sale'],
                        permissions: ['ex:pos', 'ex:pos:points-of-sale'],
                    },
                    context: 'shop point-of-sale',
                },
            },
            {
                path: '/point-of-sale/newsletter',
                name: 'point-of-sale:newsletter',
                component: () => import('@/extensions/shop/pointOfSale/views/Newsletter.vue'),
                meta: {
                    title: project + ' Point Of Sale Newsletter',
                    restrictions: {
                        extensions: ['shop', 'shop:point-of-sale', 'newsletter'],
                        permissions: ['ex:pos', 'ex:pos:points-of-sale', 'ex:newsletter'],
                    },
                    context: 'shop point-of-sale',
                },
            },
            {
                path: '/point-of-sale/conversations/:id?',
                name: 'point-of-sale:conversations',
                component: () => import('@/extensions/communication/views/PointOfSale/Messages.vue'),
                meta: {
                    title: project + ' Point Of Sale Conversations',
                    restrictions: {
                        extensions: ['shop', 'shop:point-of-sale', 'communication'],
                        permissions: ['ex:pos', 'ex:pos:points-of-sale', 'ex:comm:messages'],
                    },
                    context: 'shop point-of-sale',
                },
            },
        ],
    },
    // Marketing
    {
        path: '/marketing',
        name: 'marketing',
        // redirect: '/marketing/statistics',
        component: () => import('@/views/cms/Marketing.vue'),
        meta: {
            restrictions: {
                extensions: [],
                permissions: ['statistics||ex:shop||ex:marketing||ex:newsletter'],
            },
        },
    },
    {
        path: '/marketing/statistics',
        name: 'statistics',
        component: () => import('@/views/cms/Marketing/Statistics.vue'),
        meta: {
            title: project + ' Statistics',
            parent: 'marketing',
            restrictions: {
                extensions: [],
                permissions: ['statistics||ex:marketing'],
            },
            context: 'marketing',
        },
    },
    {
        path: '/marketing/campaigns',
        name: 'campaigns',
        component: () => import('@/extensions/marketing/views/Campaign/List.vue'),
        meta: {
            title: project + ' Marketing Campaigns',
            parent: 'marketing',
            restrictions: {
                extensions: ['marketing'],
                permissions: ['ex:marketing', 'ex:marketing:campaigns'],
            },
            context: 'marketing',
        },
    },
    {
        path: '/marketing/campaign/:id?',
        name: 'campaign-form',
        component: () => import('@/extensions/marketing/views/Campaign/Form.vue'),
        meta: {
            title: project + ' Marketing Campaign',
            parent: 'marketing',
            restrictions: {
                extensions: ['marketing'],
                permissions: ['ex:marketing', 'ex:marketing:campaigns'],
            },
            context: 'marketing',
        },
        children: [
            {
                path: '/marketing/campaign/:id/main',
                name: 'campaign-main',
                component: () => import('@/extensions/marketing/views/Campaign/Form/Main.vue'),
                meta: {
                    title: project + ' Marketing Campaign',
                    restrictions: {
                        extensions: ['marketing'],
                        permissions: ['ex:marketing', 'ex:marketing:campaigns'],
                    },
                    context: 'marketing',
                },
            },
        ],
    },
    {
        path: '/marketing/meta-pixel',
        name: 'meta-pixel',
        component: () => import('@/extensions/marketing/views/MetaPixel/Form.vue'),
        meta: {
            title: project + ' Meta Pixel',
            parent: 'marketing',
            restrictions: {
                extensions: ['marketing'],
                permissions: ['ex:marketing', 'ex:marketing:meta-pixel'],
            },
            context: 'marketing',
        },
    },
    {
        path: '/marketing/google-tag-manager',
        name: 'google-tag-manager',
        component: () => import('@/extensions/marketing/views/GoogleTagManager/Form.vue'),
        meta: {
            title: project + ' Google Tag Manager',
            parent: 'marketing',
            restrictions: {
                extensions: ['marketing'],
                permissions: ['ex:marketing', 'ex:marketing:google-tag-manager'],
            },
            context: 'marketing',
        },
    },
    {
        path: '/chatbot/chats',
        name: 'chatbot-conversations',
        component: () => import('@/extensions/chatbot/views/Chat/List.vue'),
        meta: {
            title: project + ' Chatbot Chats',
            parent: 'ai-tools',
            restrictions: {
                extensions: ['chatbot'],
            },
        },
    },
    {
        path: '/chatbot/chat/:id',
        name: 'chatbot-conversation-detail',
        component: () => import('@/extensions/chatbot/views/Chat/Detail.vue'),
        meta: {
            title: project + ' Chatbot Chat',
            parent: 'ai-tools',
            restrictions: {
                extensions: ['chatbot'],
            },
        },
    },
    // The knowledge base belongs to the CMS, shared by the chatbot and KI-Inhalte;
    // the old chatbot path keeps bookmarks working.
    {
        path: '/chatbot/knowledge-base',
        redirect: '/ai-tools/knowledge-base',
    },
    {
        path: '/ai-tools/knowledge-base',
        name: 'knowledge-base',
        component: () => import('@/extensions/knowledge-base/views/KnowledgeBase.vue'),
        meta: {
            title: project + ' Knowledge Base',
            parent: 'ai-tools',
            restrictions: {
                // shared by the chatbot and KI-Inhalte
                extensions: ['chatbot'],
                activeExtensions: ['ai-content'],
            },
        },
    },
    {
        path: '/ai-tools/prompt-templates',
        name: 'ai-prompt-templates',
        component: () => import('@/extensions/generative-media/views/PromptTemplates/List.vue'),
        meta: {
            title: project + ' AI Prompt Templates',
            parent: 'ai-tools',
            restrictions: {
                // ai-image-edit is a SYSTEM-WIDE extension (never template-listed) —
                // gated against the CMS's active extensions, not enabledExtensions.
                activeExtensions: ['ai-image-edit'],
            },
        },
    },
    {
        path: '/marketing/newsletters',
        name: 'newsletters',
        component: () => import('@/extensions/newsletter/views/Newsletter/List.vue'),
        meta: {
            title: project + ' Newsletters',
            parent: 'marketing',
            restrictions: {
                extensions: ['newsletter'],
                permissions: ['ex:newsletter'],
            },
            context: 'marketing',
        },
    },
    {
        path: '/marketing/newsletter/:id?',
        name: 'newsletter-form',
        component: () => import('@/extensions/newsletter/views/Newsletter/Form.vue'),
        meta: {
            title: project + ' Newsletter',
            parent: 'marketing',
            restrictions: {
                extensions: ['newsletter'],
                permissions: ['ex:newsletter'],
            },
            context: 'marketing',
        },
        children: [
            {
                path: '/marketing/newsletter/:id/main',
                name: 'newsletter-main',
                component: () => import('@/extensions/newsletter/views/Newsletter/Form/Main.vue'),
                meta: {
                    title: project + ' Newsletter',
                    restrictions: {
                        extensions: ['newsletter'],
                        permissions: ['ex:newsletter'],
                    },
                    context: 'marketing',
                },
            },
            {
                path: '/marketing/newsletter/:id/delivery',
                name: 'newsletter-delivery',
                component: () => import('@/extensions/newsletter/views/Newsletter/Form/Delivery.vue'),
                meta: {
                    title: project + ' Newsletter',
                    restrictions: {
                        extensions: ['newsletter'],
                        permissions: ['ex:newsletter'],
                    },
                    context: 'marketing',
                },
            },
            {
                path: '/marketing/newsletter/:id/settings',
                name: 'newsletter-settings',
                component: () => import('@/extensions/newsletter/views/Newsletter/Form/Settings.vue'),
                meta: {
                    title: project + ' Newsletter',
                    restrictions: {
                        extensions: ['newsletter'],
                        permissions: ['ex:newsletter'],
                    },
                    context: 'marketing',
                },
            },
        ],
    },
    {
        path: '/marketing/newsletter-subscription-topics',
        name: 'newsletter-subscription-topics',
        component: () => import('@/extensions/newsletter/views/SubscriptionTopic/List.vue'),
        meta: {
            title: project + ' Newsletter Subscription Topics',
            parent: 'marketing',
            restrictions: {
                extensions: ['newsletter'],
                permissions: ['ex:newsletter', 'ex:newsletter:topics'],
            },
            context: 'marketing',
        },
    },
    {
        path: '/marketing/newsletter-subscription-topic/:id?',
        name: 'newsletter-subscription-topic-form',
        component: () => import('@/extensions/newsletter/views/SubscriptionTopic/Form.vue'),
        meta: {
            title: project + ' Newsletter Subscription Topic',
            parent: 'marketing',
            restrictions: {
                extensions: ['newsletter'],
                permissions: ['ex:newsletter', 'ex:newsletter:topics'],
            },
            context: 'marketing',
        },
        children: [
            {
                path: '/marketing/newsletter-subscription-topic/:id/main',
                name: 'newsletter-subscription-topic-main',
                component: () => import('@/extensions/newsletter/views/SubscriptionTopic/Form/Main.vue'),
                meta: {
                    title: project + ' Newsletter Subscription Topic',
                    restrictions: {
                        extensions: ['newsletter'],
                        permissions: ['ex:newsletter', 'ex:newsletter:topics'],
                    },
                    context: 'marketing',
                },
            },
        ],
    },
    {
        path: '/marketing/coupons',
        name: 'coupons',
        component: () => import('@/extensions/shop/views/Coupon/List.vue'),
        meta: {
            title: project + ' Marketing Coupons',
            parent: 'marketing',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop', 'ex:shop:coupons'],
            },
            context: 'marketing',
            // Multistore: this data lives on the shop and is shared with every
            // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
            sharedWithShop: true,
        },
    },
    {
        path: '/people/customer-groups',
        name: 'customer-groups',
        component: () => import('@/extensions/shop/views/CustomerGroup/List.vue'),
        meta: {
            title: project + ' Kundengruppen',
            parent: 'people',
            restrictions: {
                extensions: ['shop'],
                permissions: ['ex:shop'],
            },
            context: 'people',
            // Multistore: this data lives on the shop and is shared with every
            // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
            sharedWithShop: true,
        },
    },
    // {
    //     path: '/marketing/coupons/:id?',
    //     name: 'coupons-form',
    //     component: () => import('@/extensions/shop/views/Coupons/Form.vue'),
    //     meta: {
    //         title: project + ' Marketing Coupons',
    //         parent: 'marketing',
    //         restrictions: {
    //             extensions: ['shop'],
    //             permissions: ['ex:shop', 'ex:shop:coupons'],
    //         },
    //         context: 'marketing'
    //     },
    //     children: [
    //         {
    //             path: '/marketing/coupons/:id/main',
    //             component: () => import('@/extensions/shop/views/Coupons/Form/Main.vue'),
    //             name: 'coupons-main',
    //             meta: {
    //                 title: project + ' Marketing Coupons',
    //                 restrictions: {
    //                     extensions: ['shop'],
    //                     permissions: ['ex:shop', 'ex:shop:coupons'],
    //                 },
    //                 context: 'marketing'
    //             }
    //         },
    //     ]
    // },
    // People
    {
        path: '/members',
        name: 'member-list',
        component: () => import('@/extensions/restrictedArea/views/Member/List.vue'),
        meta: {
            title: project + ' Members',
            restrictions: {
                extensions: ['restricted-area', 'shop'],
                permissions: ['ex:rstrct||ex:shop', 'ex:rstrct:members'],
            },
            context: 'restricted-area',
        },
    },
    {
        path: '/member/:id?',
        name: 'member-form',
        component: () => import('@/extensions/restrictedArea/views/Member/Form.vue'),
        meta: {
            title: project + ' Member',
            parent: 'member-list',
            restrictions: {
                extensions: ['restricted-area', 'shop'],
                permissions: ['ex:rstrct||ex:shop', 'ex:rstrct:members'],
            },
            context: 'restricted-area',
        },
        children: [
            {
                path: '/member/:id/main',
                name: 'member-main',
                component: () => import('@/extensions/restrictedArea/views/Member/Form/Main.vue'),
                meta: {
                    title: project + ' Member',
                    restrictions: {
                        extensions: ['restricted-area', 'shop'],
                        permissions: ['ex:rstrct||ex:shop', 'ex:rstrct:members'],
                    },
                    context: 'restricted-area',
                },
            },
            // {
            //     path: '/member/:id/addresses',
            //     name: 'member-addresses',
            //     component: () => import('@/extensions/restrictedArea/views/Member/Form/Addresses.vue'),
            //     meta: {
            //         title: project + ' Addresses',
            //         restrictions: {
            //             extensions: ['restricted-area', 'shop'],
            //             permissions: ['ex:rstrct', 'ex:rstrct:members'],
            //         },
            //         context: 'restricted-area'
            //     }
            // },
            {
                path: '/member/:id/customer',
                name: 'member-customer',
                component: () => import('@/extensions/restrictedArea/views/Member/Form/Customer.vue'),
                meta: {
                    title: project + ' Customer',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:rstrct:members'],
                    },
                    context: 'restricted-area',
                },
            },
            {
                path: '/member/:id/purchases',
                name: 'member-purchases',
                component: () => import('@/extensions/restrictedArea/views/Member/Form/Purchases.vue'),
                meta: {
                    title: project + ' Purchases',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop', 'ex:rstrct:members'],
                    },
                    context: 'restricted-area',
                },
            },
            // {
            //     path: '/member/:id/tags',
            //     name: 'member-tags',
            //     component: () => import('@/extensions/restrictedArea/views/Member/Form/Tags.vue'),
            //     meta: {
            //         title: project + ' Tag',
            //         restrictions: {
            //             extensions: ['restricted-area'],
            //             permissions: ['ex:rstrct', 'ex:rstrct:members'],
            //         },
            //         context: 'restricted-area'
            //     }
            // },
            {
                path: '/member/:id/documents',
                name: 'member-documents',
                component: () => import('@/extensions/restrictedArea/views/Member/Form/Documents.vue'),
                meta: {
                    title: project + ' Documents',
                    restrictions: {
                        extensions: ['restricted-area', 'shop'],
                        permissions: ['ex:rstrct||ex:shop', 'ex:rstrct:members'],
                    },
                    context: 'restricted-area',
                },
            },
            {
                path: '/member/:id/messages/:conversationId?',
                name: 'member-messages',
                component: () => import('@/extensions/communication/views/Member/Messages.vue'),
                meta: {
                    title: project + ' Messages',
                    restrictions: {
                        extensions: ['communication'],
                        permissions: ['ex:comm', 'ex:comm:messages'],
                    },
                    context: 'restricted-area',
                },
            },
        ],
    },
    // Forms
    {
        path: '/form-entries',
        name: 'form-entries',
        component: () => import('@/extensions/forms/views/Entry/List.vue'),
        meta: {
            title: project + ' Form Entries',
            parent: 'form-entries',
            restrictions: {
                extensions: ['forms'],
                permissions: ['ex:frms', 'ex:frms:entries'],
            },
            context: 'forms',
        },
    },
    // Customer Communication
    {
        path: '/conversations/:id?',
        name: 'messages',
        component: () => import('@/extensions/communication/views/Conversation/Inbox.vue'),
        meta: {
            title: project + ' Messages',
            parent: 'messages',
            restrictions: {
                extensions: ['communication'],
                permissions: ['ex:comm', 'ex:comm:messages'],
            },
            context: 'communication',
        },
    },
    // Legacy path kept so existing /messages links/bookmarks still resolve.
    {
        path: '/messages/:id?',
        redirect: (to) => ({ name: 'messages', params: to.params }),
    },
    // Tickets (CMS surface, billable feature)
    {
        path: '/tickets/gantt',
        name: 'ticket-gantt',
        component: () => import('@/extensions/tickets/views/CmsTicketGantt.vue'),
        meta: {
            title: project + ' Tickets',
            parent: 'messages',
            restrictions: {
                extensions: ['tickets'],
                permissions: ['ex:tckt', 'ex:tckt:tickets'],
            },
            context: 'communication',
        },
    },
    // Both project routes MUST stay above /tickets/:id - it matches
    // "projects" happily, and the failure looks like the project list showing a
    // ticket detail error.
    {
        path: '/tickets/times',
        name: 'ticket-times',
        component: () => import('@/extensions/tickets/views/CmsTimeEntryList.vue'),
        meta: {
            title: project + ' Zeiten',
            parent: 'messages',
            restrictions: {
                extensions: ['tickets'],
                permissions: ['ex:tckt', 'ex:tckt:tickets'],
            },
            context: 'communication',
        },
    },
    {
        path: '/tickets/projects',
        name: 'projects',
        component: () => import('@/extensions/tickets/views/Projects/CmsProjectList.vue'),
        meta: {
            title: project + ' Projekte',
            parent: 'messages',
            restrictions: {
                extensions: ['tickets'],
                permissions: ['ex:tckt', 'ex:tckt:tickets'],
            },
            context: 'communication',
        },
    },
    {
        path: '/tickets/projects/:id',
        name: 'project-detail',
        component: () => import('@/extensions/tickets/views/Projects/CmsProjectDetail.vue'),
        meta: {
            title: project + ' Projekte',
            parent: 'messages',
            restrictions: {
                extensions: ['tickets'],
                permissions: ['ex:tckt', 'ex:tckt:tickets'],
            },
            context: 'communication',
        },
    },
    {
        path: '/tickets/:id',
        name: 'ticket-detail',
        component: () => import('@/extensions/tickets/views/CmsTicketDetail.vue'),
        meta: {
            title: project + ' Tickets',
            parent: 'messages',
            restrictions: {
                extensions: ['tickets'],
                permissions: ['ex:tckt', 'ex:tckt:tickets'],
            },
            context: 'communication',
        },
    },
    {
        path: '/tickets',
        name: 'tickets',
        component: () => import('@/extensions/tickets/views/CmsTicketList.vue'),
        meta: {
            title: project + ' Tickets',
            parent: 'messages',
            restrictions: {
                extensions: ['tickets'],
                permissions: ['ex:tckt', 'ex:tckt:tickets'],
            },
            context: 'communication',
        },
    },
    {
        path: '/communication/settings',
        redirect: '/settings/communication',
        meta: {
            title: project + ' Communication — Settings',
            restrictions: {
                extensions: ['communication'],
                permissions: ['ex:comm', 'ex:comm:accounts'],
            },
            context: 'settings',
        },
    },
    // Files
    {
        path: '/files',
        name: 'files',
        component: () => import('@/views/cms/FileManager/List.vue'),
        meta: {
            title: project + ' Files',
            parent: 'files',
            restrictions: {
                extensions: [],
                permissions: ['files'],
            },
            context: 'files',
        },
    },
    // System Administration
    {
        path: '/system',
        name: 'system',
        redirect: '/system/accounts',
        component: () => import('@/views/system/Account/List.vue'),
        children: [
            {
                path: '/system/accounts',
                name: 'system-accounts',
                component: () => import('@/views/system/Account/List/Accounts.vue'),
                meta: {
                    title: project + ' Accounts',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                        permissions: ['superuser'],
                    },
                    context: 'system',
                },
            },
            {
                path: '/system/abonements',
                name: 'system-abonements',
                component: () => import('@/views/system/Account/List/Abonements.vue'),
                meta: {
                    title: project + ' Accounts',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                        permissions: ['superuser'],
                    },
                    context: 'system',
                },
            },
            {
                path: '/system/billing',
                name: 'system-billing',
                component: () => import('@/views/system/Billing/List.vue'),
                meta: {
                    title: project + ' Billing',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                        permissions: ['superuser'],
                    },
                    context: 'system',
                },
            },
            {
                path: '/system/tickets',
                name: 'system-tickets',
                component: () => import('@/extensions/tickets/views/SystemTicketList.vue'),
                meta: {
                    title: project + ' Tickets',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                        permissions: ['superuser'],
                    },
                    context: 'system',
                },
            },
            {
                path: '/system/provider-costs',
                name: 'system-provider-costs',
                component: () => import('@/views/system/ProviderCosts/List.vue'),
                meta: {
                    title: project + ' Provider Costs',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                        permissions: ['superuser'],
                    },
                    context: 'system',
                },
            },
            // {
            //     path: '/member/:id/addresses',
            //     name: 'member-addresses',
            //     component: () => import('@/extensions/restrictedArea/views/Member/Form/Addresses.vue'),
            //     meta: {
            //         title: project + ' Addresses',
            //         restrictions: {
            //             extensions: ['restricted-area', 'shop'],
            //             permissions: ['ex:rstrct', 'ex:rstrct:members'],
            //         },
            //         context: 'restricted-area'
            //     }
            // },
            // {
            //     path: '/member/:id/customer',
            //     name: 'member-customer',
            //     component: () => import('@/extensions/restrictedArea/views/Member/Form/Customer.vue'),
            //     meta: {
            //         title: project + ' Customer',
            //         restrictions: {
            //             extensions: ['shop'],
            //             permissions: ['ex:shop', 'ex:rstrct', 'ex:rstrct:members'],
            //         },
            //         context: 'restricted-area'
            //     }
            // },
            // {
            //     path: '/member/:id/purchases',
            //     name: 'member-purchases',
            //     component: () => import('@/extensions/restrictedArea/views/Member/Form/Purchases.vue'),
            //     meta: {
            //         title: project + ' Purchases',
            //         restrictions: {
            //             extensions: ['shop'],
            //             permissions: ['ex:shop', 'ex:rstrct', 'ex:rstrct:members'],
            //         },
            //         context: 'restricted-area'
            //     }
            // },
            // {
            //     path: '/member/:id/tags',
            //     name: 'member-tags',
            //     component: () => import('@/extensions/restrictedArea/views/Member/Form/Tags.vue'),
            //     meta: {
            //         title: project + ' Tag',
            //         restrictions: {
            //             extensions: ['restricted-area'],
            //             permissions: ['ex:rstrct', 'ex:rstrct:members'],
            //         },
            //         context: 'restricted-area'
            //     }
            // },
            // {
            //     path: '/member/:id/documents',
            //     name: 'member-documents',
            //     component: () => import('@/extensions/restrictedArea/views/Member/Form/Documents.vue'),
            //     meta: {
            //         title: project + ' Documents',
            //         restrictions: {
            //             extensions: ['restricted-area'],
            //             permissions: ['ex:rstrct', 'ex:rstrct:members'],
            //         },
            //         context: 'restricted-area'
            //     }
            // }
        ],
    },
    // Tickets (super users only)
    {
        path: '/system/tickets/gantt',
        name: 'system-ticket-gantt',
        component: () => import('@/extensions/tickets/views/SystemTicketGantt.vue'),
        meta: {
            title: project + ' Tickets',
            parent: 'system',
            restrictions: {
                extensions: [],
                permissions: ['superuser'],
            },
            context: 'system',
        },
    },
    // Same ordering trap as the tenant surface.
    // Top-level, not a child of the /system shell: this page renders its own tab
    // bar so it has somewhere to put a Save (the shell's router-view cannot reach
    // the bar's slot). Same reason the ticket pages sit out here.
    {
        path: '/system/settings',
        name: 'system-settings',
        component: () => import('@/views/system/PlatformSettings/Index.vue'),
        meta: {
            title: project + ' Platform Settings',
            parent: 'system',
            restrictions: {
                extensions: [],
                permissions: ['superuser'],
            },
            context: 'system',
        },
    },
    // Detail before list is deliberate here only for readability; vue-router
    // matches the static path first either way.
    {
        path: '/system/team',
        name: 'system-team',
        component: () => import('@/views/system/Team/SystemTeamList.vue'),
        meta: {
            title: project + ' Team',
            parent: 'system',
            restrictions: {
                extensions: [],
                permissions: ['superuser'],
            },
            context: 'system',
        },
    },
    // Static before the parameter route, or `absences` would be read as an id.
    // Every super user, not only support-time holders: who is away is what
    // the whole team needs to know.
    {
        path: '/system/team/absences',
        name: 'system-team-absences',
        component: () => import('@/views/system/Team/Absences.vue'),
        meta: {
            title: project + ' Abwesenheiten',
            parent: 'system',
            restrictions: {
                extensions: [],
                permissions: ['superuser'],
            },
            context: 'system',
            requiresSuperUser: true,
        },
    },
    // Static before the parameter route, or `sessions` would be read as an id.
    {
        path: '/system/team/sessions',
        name: 'system-team-impersonation-sessions',
        component: () => import('@/views/system/Team/ImpersonationSessions.vue'),
        meta: {
            title: project + ' Support-Sitzungen',
            parent: 'system',
            restrictions: {
                extensions: [],
                permissions: ['superuser'],
            },
            context: 'system',
            requiresSuperUser: true,
        },
    },
    {
        path: '/system/team/:id',
        name: 'system-team-detail',
        component: () => import('@/views/system/Team/SystemTeamDetail.vue'),
        meta: {
            title: project + ' Team',
            parent: 'system',
            restrictions: {
                extensions: [],
                permissions: ['superuser'],
            },
            context: 'system',
        },
    },
    {
        path: '/system/tickets/times',
        name: 'system-ticket-times',
        component: () => import('@/extensions/tickets/views/SystemTimeEntryList.vue'),
        meta: {
            title: project + ' Zeiten',
            parent: 'system',
            restrictions: {
                extensions: [],
                permissions: ['superuser'],
            },
            context: 'system',
        },
    },
    {
        path: '/system/tickets/projects',
        name: 'system-projects',
        component: () => import('@/extensions/tickets/views/Projects/SystemProjectList.vue'),
        meta: {
            title: project + ' Projekte',
            parent: 'system',
            restrictions: {
                extensions: [],
                permissions: ['superuser'],
            },
            context: 'system',
        },
    },
    {
        path: '/system/tickets/projects/:id',
        name: 'system-project-detail',
        component: () => import('@/extensions/tickets/views/Projects/SystemProjectDetail.vue'),
        meta: {
            title: project + ' Projekte',
            parent: 'system',
            restrictions: {
                extensions: [],
                permissions: ['superuser'],
            },
            context: 'system',
        },
    },
    {
        path: '/system/tickets/:id',
        name: 'system-ticket-detail',
        component: () => import('@/extensions/tickets/views/SystemTicketDetail.vue'),
        meta: {
            title: project + ' Tickets',
            parent: 'system',
            restrictions: {
                extensions: [],
                permissions: ['superuser'],
            },
            context: 'system',
        },
    },
    // Billing Detail (super users only)
    {
        path: '/system/billing/:id',
        name: 'system-billing-detail',
        component: () => import('@/views/system/Billing/Detail.vue'),
        redirect: { name: 'system-billing-current' },
        meta: {
            title: project + ' Billing Detail',
            parent: 'system',
            restrictions: {
                extensions: [],
                permissions: ['superuser'],
            },
            context: 'system',
        },
        children: [
            {
                path: '/system/billing/:id/current',
                name: 'system-billing-current',
                component: () => import('@/views/system/Billing/Detail/CurrentPeriod.vue'),
                meta: {
                    title: project + ' Current Period',
                    restrictions: {
                        extensions: [],
                        permissions: ['superuser'],
                    },
                    context: 'system',
                },
            },
            {
                path: '/system/billing/:id/history',
                name: 'system-billing-history',
                component: () => import('@/views/system/Billing/Detail/History.vue'),
                meta: {
                    title: project + ' Billing History',
                    restrictions: {
                        extensions: [],
                        permissions: ['superuser'],
                    },
                    context: 'system',
                },
            },
            {
                path: '/system/billing/:id/features',
                name: 'system-billing-features',
                component: () => import('@/views/system/Billing/Detail/Features.vue'),
                meta: {
                    title: project + ' Features',
                    restrictions: {
                        extensions: [],
                        permissions: ['superuser'],
                    },
                    context: 'system',
                },
            },
            {
                path: '/system/billing/:id/settings',
                name: 'system-billing-settings',
                component: () => import('@/views/system/Billing/Detail/Settings.vue'),
                meta: {
                    title: project + ' Billing Settings',
                    restrictions: {
                        extensions: [],
                        permissions: ['superuser'],
                    },
                    context: 'system',
                },
            },
        ],
    },
    // CMS Wizard (super users only)
    {
        path: '/system/cms/new',
        name: 'system-cms-wizard',
        component: () => import('@/views/system/CmsWizard/index.vue'),
        meta: {
            title: project + ' New CMS',
            parent: 'system',
            restrictions: {
                extensions: [],
                permissions: ['superuser'],
            },
            context: 'system',
        },
    },
    // CMS Setup Wizard (first-login for unconfigured CMS)
    {
        path: '/setup/:cms?',
        name: 'cms-setup-wizard',
        component: () => import('@/views/system/CmsWizard/index.vue'),
        meta: {
            title: project + ' Setup',
            context: 'setup',
        },
    },
    // {
    //     path: '/system/accounts',
    //     name: 'accounts',
    //     component: () => import('@/views/system/Account/List.vue'),
    //     meta: {
    //         title: project + ' Accounts',
    //         parent: 'system',
    //         restrictions: {
    //             extensions: [],
    //             permissions: ['superuser'],
    //         },
    //         context: 'system'
    //     }
    // },
    {
        path: '/account/billing',
        name: 'system-account-billing',
        component: () => import('@/views/system/Account/Billing.vue'),
        meta: {
            title: project + ' Billing & costs',
            parent: 'system',
            restrictions: {
                extensions: [],
            },
            context: 'system',
            // Temporarily restricted to super-users (or super-users impersonating).
            requiresSuperUser: true,
        },
    },
    {
        path: '/account/:id?',
        // path: '/system/account',
        name: 'system-account-form',
        component: () => import('@/views/system/Account/Form.vue'),
        meta: {
            title: project + ' Account',
            parent: 'system',
            restrictions: {
                extensions: [],
                // permissions: ['superuser'],
            },
            context: 'system',
        },
        children: [
            {
                path: '/account/:id?/main',
                // path: '/system/account/main',
                name: 'system-account-main',
                component: () => import('@/views/system/Account/Form/Main.vue'),
                meta: {
                    title: project + ' Account',
                    restrictions: {
                        extensions: [],
                        // permissions: ['superuser'],
                    },
                    context: 'system',
                },
            },
            // {
            //     path: '/account/:id?/abonements',
            //     name: 'account-abonements',
            //     component: () => import('@/views/system/Account/Form/Abonements.vue'),
            //     meta: {
            //         title: project + ' Abonements',
            //         restrictions: {
            //             extensions: [],
            //             permissions: ['superuser'],
            //         },
            //         context: 'system'
            //     }
            // },
            {
                // One team member's booked time on this shop's own desk. Under
                // the team route so it keeps the account chrome around it.
                path: '/account/:id/team/:userId',
                name: 'account-team-member',
                component: () => import('@/views/system/Team/AccountTeamMember.vue'),
                meta: {
                    title: project + ' Team',
                    restrictions: {
                        extensions: [],
                    },
                    context: 'system',
                },
            },
            {
                path: '/account/:id?/team',
                // path: '/system/account/team',
                name: 'system-account-team',
                component: () => import('@/views/system/Account/Form/Team.vue'),
                meta: {
                    title: project + ' Team',
                    restrictions: {
                        extensions: [],
                        // permissions: ['superuser'],
                    },
                    context: 'system',
                },
            },
        ],
    },
    // {
    //     path: '/system/abonements',
    //     name: 'abonements',
    //     component: () => import('@/views/system/Account/AbonementList.vue'),
    //     meta: {
    //         title: project + ' Abonements',
    //         parent: 'system',
    //         restrictions: {
    //             extensions: [],
    //             permissions: ['superuser'],
    //         },
    //         context: 'system'
    //     }
    // },
    // Settings
    // {
    //     path: '/settings',
    //     name: 'settings',
    //     component: () => import('@/views/settings/Form.vue'),
    //     meta: {
    //         title: project + ' Settings',
    //         restrictions: {
    //             extensions: [],
    //             permissions: ['settings'],
    //         },
    //         context: 'main',
    //     }
    // },
    {
        path: '/settings/:id?',
        name: 'settings-form',
        component: () => import('@/views/settings/Account/Form.vue'),
        // redirect: '/settings/basic',
        meta: {
            title: project + ' Settings',
            restrictions: {
                extensions: [],
                // permissions: ['superuser'],
            },
            context: 'main',
        },
        children: [
            {
                path: '/settings/:id?/basic',
                name: 'settings-basic',
                component: () => import('@/views/settings/Account/Form/AbonementBasic.vue'),
                meta: {
                    title: project + ' Account',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                        // permissions: ['superuser'],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/business-card',
                name: 'settings-business-card',
                component: () => import('@/views/settings/Account/Form/AbonementBusinessCard.vue'),
                meta: {
                    title: project + ' Business Card',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/api',
                name: 'settings-api',
                component: () => import('@/views/settings/Account/Form/AbonementAPI.vue'),
                meta: {
                    title: project + ' Account',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                        // permissions: ['superuser'],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/design',
                name: 'settings-design',
                component: () => import('@/views/settings/Account/Form/AbonementDesign.vue'),
                meta: {
                    title: project + ' Design',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                        // permissions: ['superuser'],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/sections',
                name: 'settings-sections',
                component: () => import('@/views/settings/Account/Form/AbonementSections.vue'),
                meta: {
                    title: project + ' Sections',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/global-contents',
                name: 'settings-global-contents',
                component: () => import('@/views/settings/Account/Form/AbonementGlobalContents.vue'),
                meta: {
                    title: project + ' Global Contents',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/document-templates',
                name: 'settings-document-templates',
                component: () => import('@/views/settings/Account/Form/AbonementDocumentTemplates.vue'),
                meta: {
                    title: project + ' Document Templates',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/communication',
                name: 'settings-communication',
                component: () => import('@/extensions/communication/views/ChannelAccount/List.vue'),
                meta: {
                    title: project + ' Communication',
                    parent: 'system',
                    // The page also hosts the transactional + newsletter SMTP config,
                    // which shop/forms/newsletter CMSes need without the communication
                    // extension. Reachability is requirement-driven (like settings-api);
                    // the component's own guard 403s when nothing applies.
                    restrictions: {
                        extensions: [],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/shop',
                name: 'settings-shop',
                component: () => import('@/views/settings/Account/Form/AbonementShop.vue'),
                meta: {
                    title: project + ' Shop',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                        // permissions: ['superuser'],
                    },
                    context: 'settings',
                    // Multistore: writing the shop-owned fields on this screen needs the
                    // rights of the OWNER store, so the permission gate stays on.
                    sharedWithShop: true,
                    // ...but unlike the other shop-owned screens, most of this one is NOT
                    // shared - the identity block writes a satellite's own override, and
                    // numbering is per store. A banner over the whole page would say the
                    // opposite, so the sections that really are shared say so themselves.
                    sharedWithShopBanner: false,
                },
            },
            {
                path: '/settings/:id?/stocks',
                name: 'settings-stocks',
                component: () => import('@/views/settings/Account/Form/Stocks.vue'),
                meta: {
                    title: project + ' Stocks',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                        // permissions: ['superuser'],
                    },
                    context: 'settings',
                    // Multistore: this data lives on the shop and is shared with every
                    // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
                    sharedWithShop: true,
                },
            },
            {
                path: '/settings/:id?/pos',
                name: 'settings-pos',
                component: () => import('@/views/settings/Account/Form/POS.vue'),
                meta: {
                    title: project + ' POS',
                    parent: 'system',
                    restrictions: {
                        // The nav entry was the only thing gating this; by URL the page
                        // opened on any store. A terminal is a separately sold add-on,
                        // so the extension has to be present on THIS store.
                        extensions: ['shop:point-of-sale'],
                        permissions: ['ex:pos', 'ex:pos:points-of-sale'],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/shipping-methods',
                name: 'shipping-methods',
                component: () => import('@/views/settings/Account/Form/ShippingMethods.vue'),
                meta: {
                    title: project + ' Versand-Methoden',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                    },
                    context: 'settings',
                },
            },
            // (Return reasons settings live inline inside the Shop tab — no dedicated route.)
            {
                path: '/settings/:id?/payment-methods',
                name: 'payment-methods',
                component: () => import('@/views/settings/Account/Form/PaymentMethods.vue'),
                meta: {
                    title: project + ' Zahlungsarten',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/currencies',
                name: 'currencies',
                component: () => import('@/extensions/shop/views/Currency/List.vue'),
                meta: {
                    title: project + ' Währungen',
                    parent: 'system',
                    restrictions: {
                        extensions: ['shop'],
                        permissions: ['ex:shop'],
                    },
                    context: 'settings',
                    // Multistore: this data lives on the shop and is shared with every
                    // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
                    sharedWithShop: true,
                },
            },
            {
                path: '/settings/:id?/billing',
                name: 'settings-billing',
                component: () => import('@/views/settings/Account/Form/BillingSettings.vue'),
                meta: {
                    title: project + ' Billing',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/knowledge-base',
                name: 'settings-knowledge-base',
                component: () => import('@/views/settings/Account/Form/KnowledgeBase.vue'),
                meta: {
                    title: project + ' Knowledge Base',
                    parent: 'system',
                    restrictions: {
                        // shared by the chatbot and KI-Inhalte, like /ai-tools/knowledge-base
                        extensions: ['chatbot'],
                        activeExtensions: ['ai-content'],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/chatbot',
                name: 'settings-chatbot',
                component: () => import('@/views/settings/Account/Form/Chatbot.vue'),
                meta: {
                    title: project + ' Chatbot',
                    parent: 'system',
                    restrictions: {
                        extensions: ['chatbot'],
                    },
                    context: 'settings',
                },
            },
            {
                path: '/settings/:id?/ai',
                name: 'settings-ai',
                component: () => import('@/views/settings/Account/Form/Ai.vue'),
                meta: {
                    title: project + ' AI',
                    parent: 'system',
                    restrictions: {
                        extensions: [],
                    },
                    context: 'settings',
                },
            },
        ],
    },
    // Table Reservations
    {
        path: '/table-reservations',
        name: 'table-reservations',
        component: () => import('@/extensions/tableReservation/views/index.vue'),
        redirect: { name: 'table-reservations-overview' },
        meta: {
            title: project + ' Reservierungen',
            restrictions: {
                extensions: ['table-reservations'],
                permissions: ['ex:trsv', 'ex:trsv:reservations'],
            },
            context: 'table-reservations',
        },
        children: [
            {
                path: '/table-reservations/overview',
                name: 'table-reservations-overview',
                component: () => import('@/extensions/tableReservation/views/Overview.vue'),
                meta: {
                    title: project + ' Reservierungen',
                    parent: 'table-reservations',
                    restrictions: {
                        extensions: ['table-reservations'],
                        permissions: ['ex:trsv', 'ex:trsv:reservations'],
                    },
                    context: 'table-reservations',
                },
            },
            {
                path: '/table-reservations/settings',
                name: 'table-reservations-settings',
                component: () => import('@/extensions/tableReservation/views/Settings/index.vue'),
                meta: {
                    title: project + ' Reservierungs-Einstellungen',
                    parent: 'table-reservations',
                    restrictions: {
                        extensions: ['table-reservations'],
                        permissions: ['ex:trsv', 'ex:trsv:settings'],
                    },
                    context: 'table-reservations',
                },
            },
        ],
    },
    {
        path: '/table-reservations/reservation/:id?',
        name: 'table-reservation-form',
        component: () => import('@/extensions/tableReservation/views/Reservations/Form.vue'),
        meta: {
            title: project + ' Reservierung',
            parent: 'table-reservations',
            restrictions: {
                extensions: ['table-reservations'],
                permissions: ['ex:trsv', 'ex:trsv:reservations'],
            },
            context: 'table-reservations',
        },
    },
    // Auth
    {
        path: '/verify-email/:id/:hash/:expires/:signature',
        name: 'verify-email',
        component: () => import('@/views/system/VerifyEmail.vue'),
        meta: {
            title: project + ' Verify Email',
            context: 'main',
            public: true,
        },
    },
    {
        path: '/resetpassword/:email/:token',
        name: 'resetpassword',
        component: () => import('@/views/system/ResetPassword.vue'),
        meta: {
            title: project + ' Reset Password',
            context: 'main',
            public: true,
        },
    },
    {
        path: '/accept-team-invitation/:token',
        name: 'accept-team-invitation',
        component: () => import('@/views/system/AcceptTeamInvitation.vue'),
        meta: {
            title: project + ' Reset Password',
            context: 'main',
            public: true,
        },
    },
    {
        // Bridge page for the mailbox OAuth popup: the API callback redirects here
        // (result in the URL fragment); the page posts it to the opener and closes.
        path: '/oauth/result',
        name: 'oauth-popup-result',
        component: () => import('@/views/system/OAuthPopupResult.vue'),
        meta: {
            title: project + ' OAuth',
            context: 'auth',
            public: true,
        },
    },
    {
        // OAuth-style loopback authorization for tooling (the Claude ticket
        // skill): ?callback=http://127.0.0.1:<port>/callback&name=<client>.
        // Not public on purpose: the SignIn overlay and redirectAfterLogin
        // bring a logged-out user back here with the query string intact.
        path: '/authorize',
        name: 'authorize-tooling',
        component: () => import('@/views/system/Authorize.vue'),
        meta: {
            title: project + ' Authorize',
            context: 'auth',
        },
    },
    {
        path: '/account',
        component: () => import('@/views/system/Account/Forward.vue'),
    },
    // {
    //     path: '/account/:id',
    //     name: 'cms-account-form',
    //     component: () => import('@/views/cms/Account/Form.vue'),
    //     meta: {
    //         title: project + ' Account',
    //         parent: 'system',
    //         restrictions: {
    //             extensions: [],
    //             // permissions: ['superuser'],
    //         },
    //         context: 'system'
    //     },
    //     children: [
    //         {
    //             path: '/account/:id/main',
    //             name: 'cms-account-main',
    //             component: () => import('@/views/cms/Account/Form/Main.vue'),
    //             meta: {
    //                 title: project + ' Account',
    //                 restrictions: {
    //                     extensions: [],
    //                     // permissions: ['superuser'],
    //                 },
    //                 context: 'system'
    //             }
    //         },
    //         {
    //             path: '/account/:id/addresses',
    //             name: 'cms-account-addresses',
    //             component: () => import('@/views/cms/Account/Form/Addresses.vue'),
    //             meta: {
    //                 title: project + ' Addresses',
    //                 restrictions: {
    //                     extensions: [],
    //                     // permissions: ['superuser'],
    //                 },
    //                 context: 'system'
    //             }
    //         },
    //         // {
    //         //     path: '/account/:id/abonements',
    //         //     name: 'cms-account-abonements',
    //         //     component: () => import('@/views/cms/Account/Form/Abonements.vue'),
    //         //     meta: {
    //         //         title: project + ' Abonements',
    //         //         restrictions: {
    //         //             extensions: [],
    //         //             // permissions: ['superuser'],
    //         //         },
    //         //         context: 'system'
    //         //     }
    //         // },
    //         {
    //             path: '/account/:id/team',
    //             name: 'cms-account-team',
    //             component: () => import('@/views/cms/Account/Form/Team.vue'),
    //             meta: {
    //                 title: project + ' Team',
    //                 restrictions: {
    //                     extensions: [],
    //                     // permissions: ['superuser'],
    //                 },
    //                 context: 'system'
    //             }
    //         }
    //     ]
    // },
    {
        path: '/stock/:id?',
        name: 'stock-form',
        component: () => import('@/extensions/shop/views/Stock/Form.vue'),
        meta: {
            title: project + ' Stocks',
            parent: 'settings-form',
            restrictions: {
                // extensions: ['shop'],
                //ex:shop:stocks -> hat dies Einfluss?
                // permissions: ['ex:shop', 'ex:shop:stocks'],
            },
            context: 'settings',
            // Multistore: this data lives on the shop and is shared with every
            // attached store, so CRUD here changes all of them (see SharedShopDataBanner).
            sharedWithShop: true,
        },
    },
    {
        path: '/pos/:id?',
        name: 'pos-form',
        component: () => import('@/extensions/shop/views/PointOfSale/Form.vue'),
        meta: {
            title: project + ' POS',
            parent: 'settings-form',
            restrictions: {
                // extensions: ['shop'],
                //ex:shop:stocks -> hat dies Einfluss?
                // permissions: ['ex:shop', 'ex:shop:stocks'],
            },
            context: 'settings',
        },
    },
    {
        path: '/shipping-method/:id?',
        name: 'shipping-method-form',
        component: () => import('@/extensions/shop/views/ShippingMethod/Form.vue'),
        meta: {
            title: project + ' Versand-Methode',
            parent: 'settings-form',
            context: 'settings',
        },
    },
    {
        path: '/payment-method/:id?',
        name: 'payment-method-form',
        component: () => import('@/extensions/shop/views/PaymentMethod/Form.vue'),
        meta: {
            title: project + ' Zahlungsart',
            parent: 'settings-form',
            context: 'settings',
        },
    },
    {
        path: '/ups-redirect',
        name: 'upsredirect',
        component: () => import('@/views/system/UpsRedirect.vue'),
        meta: {
            title: project + ' UPS',
            parent: 'settings-form',
            context: 'settings',
        },
    },
    // Public: Claim Business Card (define password)
    {
        path: '/claim-business-card/:token',
        name: 'claim-business-card',
        component: () => import('@/views/public/ClaimBusinessCard.vue'),
        meta: {
            title: project + ' Claim Business Card',
            context: 'main',
            public: true,
        },
    },
    // Tenant apps (apps/<key>/app.js), gated per CMS by their extension.
    ...appRoutes(),
    // Fallback 404
    {
        path: '*',
        name: 'Page',
        component: () => import('@/views/PageNotFound.vue'),
        meta: {
            title: 'Page Not Found',
            metaTags: [
                {
                    robots: 'noindex, nofollow',
                },
            ],
            context: 'main',
            public: true,
        },
    },
];
export default routes;
